module.exports = __webpack_public_path__ + "img/7.2b4ba3b3.jpg";